// removed by extract-text-webpack-plugin
module.exports = {"element":"y_LwW"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Checkbox/Checkbox.css
// module id = 524
// module chunks = 0